// Investigator "Suivi" dashboard (subject groups / families).
export const suivi = {
  suivi_tab_label: "Follow-up",
  suivi_caption_todo: "{{count}} to handle",
  suivi_caption_uptodate: "{{count}} up to date",
  suivi_caption_all_done: "All up to date · {{count}} records",
  suivi_search_placeholder: "Record number…",
  suivi_search_no_match: "No record matches “{{query}}”",
  suivi_group_todo_title: "To handle",
  suivi_group_uptodate_title: "Up to date",
  suivi_up_to_date_row: "Nothing to do",
  suivi_empty: "No records yet",
  suivi_dossier: "Record {{code}}",
  suivi_family: "Family",
  suivi_group_title: "Record",
  suivi_member_generic: "Participant",
  suivi_action_fill: "1 questionnaire to fill in",
  suivi_action_fill_plural: "{{count}} questionnaires to fill in",
  suivi_action_remind: "To remind",
  suivi_action_remind_role: "Remind · {{role}}",
  suivi_members: "Members",
  suivi_to_fill: "For you to fill in",
  suivi_parents_side: "Participants' side",
  suivi_history: "History",
  suivi_history_done: "{{count}} completed",
  suivi_history_missed: "{{count}} missed",
  suivi_done_on: "Done on {{date}}",
  suivi_missed_on: "Window expired · {{date}}",
  suivi_answered_by: "Answered by {{who}}",
  suivi_answered_by_you: "you",
  suivi_to_answer_by: "To be filled by {{who}}",
  suivi_questionnaire: "Questionnaire",
  suivi_fill: "Fill in",
  suivi_continue_progress: "Continue {{answered}}/{{total}}",
  suivi_filled_by_colleague: "Filled by a colleague",
  suivi_status_not_started: "Not started",
  suivi_status_in_progress: "In progress {{answered}}/{{total}}",
  suivi_call: "Call",
  suivi_copy_number: "Copy number",
  suivi_contact: "Contact",
  suivi_copy_email: "Copy email",
  suivi_email_copied: "Email copied",
  suivi_copied: "Number copied",
  suivi_during_call: "During the call",
  suivi_minutes: "≈ {{count}} min",
  suivi_mark_reminded: "Mark as reminded today",
  suivi_reminded_on: "Reminded on {{date}}",
  suivi_empty_group: "Nothing to do for this record",
  suivi_next_window_fill: "For you to fill in: {{label}} — opens on {{date}}",
  suivi_next_window_subject: "{{role}}: {{label}} — opens on {{date}}",
  suivi_home_next_window: "Next window: {{date}} ({{group}})",
  suivi_due_today: "Today",
  suivi_due_tomorrow: "Tomorrow",
  suivi_due_in_days: "{{count}} days left",
  suivi_due_past: "Expired",
  // "Add a record" — investigator dossier management.
  suivi_new_dossier_button: "New record",
  suivi_new_dossier_title: "New record",
  suivi_new_dossier_description:
    "Enter the record number and the family composition. Parents will later create their account with this same number.",
  suivi_new_dossier_create: "Create record",
  suivi_dossier_numero_label: "Record number",
  suivi_dossier_numero_required: "The record number is required",
  suivi_dossier_members_required: "Add at least one member",
  suivi_dossier_exists: "This record already exists",
  suivi_add_member_button: "Add a member",
  suivi_add_member_title: "Add a member",
  suivi_add_member_role_required: "Choose a role",
  suivi_add_member_confirm: "Add",
  suivi_add_member_done: "Member added",
  suivi_remove_member_title: "Remove this member",
  suivi_remove_member_text:
    "Remove {{role}} from this record? This is only possible while no data has been entered.",
  suivi_remove_member_confirm: "Remove",
  suivi_remove_member_done: "Member removed",
  suivi_remove_member_blocked:
    "This member already has data and can no longer be removed.",

  suivi_member_actions: "Actions",
  suivi_exit_member_title: "Exit the study",
  suivi_exit_member_text:
    "{{name}} will no longer take part in the study. Data already collected is kept; no new questionnaire will be created and no reminder will be sent.",
  suivi_exit_dossier_title: "Withdraw the whole record",
  suivi_exit_dossier_text:
    "Every member of record {{name}} will leave the study, including any attached to another centre. Data already collected is kept.",
  suivi_exit_reason_label: "Reason",
  suivi_exit_reason_withdrawal: "Withdrawal",
  suivi_exit_reason_screen_failure: "Not eligible",
  suivi_exit_reason_lost: "Lost to follow-up",
  suivi_exit_reason_error: "Enrolment error",
  suivi_exit_reason_other: "Other",
  suivi_exit_note_label: "Details (optional)",
  suivi_exit_data_label: "Data already collected",
  suivi_exit_data_keep: "Keep",
  suivi_exit_data_drop: "Stop using",
  suivi_exit_data_drop_warning:
    "This person's data will be removed from exports and will no longer be visible. This cannot be undone.",
  suivi_exit_confirm: "Confirm exit",
  suivi_exit_member_done: "Exit recorded",
  suivi_exit_dossier_done: "Record withdrawn",
  suivi_exit_dossier_button: "Withdraw the whole record",
  suivi_exited_tag: "Left the study",
  suivi_exited_tag_reason: "Left the study · {{reason}}",

  suivi_death_title: "Record a death",
  suivi_death_text:
    "Record the death of {{name}}. Data is kept and the rest of the record carries on with its follow-up.",
  suivi_death_date_label: "Date of death (optional)",
  suivi_death_confirm: "Record",
  suivi_death_done: "Death recorded",
  suivi_death_clear_title: "Undo the recorded death",
  suivi_death_clear_done: "Record undone",
  suivi_deceased_tag: "Deceased",

  suivi_access_link_title: "Send the access link",
  suivi_access_link_resend_title: "Resend the access link",
  suivi_access_link_text:
    "{{name}} will receive a link to create their account and reach their questionnaires.",
  suivi_access_link_email_label: "Email address",
  suivi_access_link_confirm: "Send",
  suivi_access_link_done: "Access link sent",
  suivi_access_link_unavailable:
    "Cannot send the link: no contact on file, or no invitation configured for this profile.",
  suivi_invited_on: "Invited on {{date}}",

  invite_relative_menu_title: "Invite {{role}}",
  invite_relative_menu_action: "Invite",
  invite_relative_title: "Invite",
  invite_relative_text:
    "They will receive a link to join your record, read the information notice and create their account.",
  invite_relative_unavailable: "No invitation is available at the moment.",
  invite_relative_firstname: "First name",
  invite_relative_lastname: "Last name",
  invite_relative_email: "Email address",
  invite_relative_role_required: "Choose who you want to invite.",
  invite_relative_fields_required: "Please fill in every field.",
  invite_relative_confirm: "Send the invitation",
  invite_relative_done: "Invitation sent",
};
